import { render } from "./BlockerProductTable.vue?vue&type=template&id=25d84041"
import script from "./BlockerProductTable.vue?vue&type=script&lang=js"
export * from "./BlockerProductTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__